import React, { FC } from "react";

export interface TotalPrintedProps {
  totalPrinted: number;
  totalItems: number;
  totalPrints?: number;
  totalReprints?: number;
}

export const TotalPrinted: FC<TotalPrintedProps> = ({
  totalPrinted,
  totalItems,
  totalPrints,
  totalReprints,
}) => (
  <span className="f6">
    Printed <b>{totalPrinted}</b>
    {" / "}
    <b>{totalItems}</b> Badges
    {totalPrints !== undefined && (
      <>
        {" — "}
        <b>{totalPrints}</b> total prints
        {totalReprints !== undefined && (
          <>
            {" ("}
            <b>{totalReprints}</b> reprints{")"}
          </>
        )}
      </>
    )}
  </span>
);
